import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../Components/ReferralsProgram/ReferralsProgram.css";
import Rewards from "../../Components/ReferralsProgram/Rewards";
import YourReferral from "../../Components/ReferralsProgram/YourReferral";
import TopUsers from "../../Components/ReferralsProgram/TopUsers";
import { Apiurl, GetLocalStorageParsed, parseData } from "../utils/page";
import axios from "axios";
const ReferralsProgram = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [tab, setTab] = useState(1);
      const [getProfileData, setGetProfielData] = useState();
    const [topUsersData, setTopUsersData] = useState([]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const GetTopUsers = () => {
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/CustomerReferrals`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setTopUsersData(data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetTopUsers();
  }, []);
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header
        setLoginToken={setLoginToken}
        setGetProfielData={setGetProfielData}
      />
      <div className="referrel-section" style={{ flex: "1" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6 col-sm-6 mb_commn_pd_0">
              <h3 className="section-title mb-0">Referral Program</h3>
            </div>

            <div className="col-12 col-lg-6 col-sm-6 mb_commn_pd_0">
              <div className="btn-text-end">
                <button
                  className={`btn btn-primary btn-show-users btn-close-style ${
                    tab == 1 ? "active-btn active_tab" : "non_active_tab"
                  }`}
                  onClick={() => setTab(1)}
                >
                  Rewards
                </button>

                <button
                  className={`btn btn-primary btn-show-users btn-show-ref-style ${
                    tab == 2 ? "active-btn active_tab" : "non_active_tab"
                  }`}
                  onClick={() => setTab(2)}
                >
                  Your Referrals
                </button>

                <button
                  className={`btn btn-primary btn-show-users btn-show-style ${
                    tab == 3 ? "active-btn active_tab" : "non_active_tab"
                  }`}
                  onClick={() => setTab(3)}
                >
                  Top Users
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {tab == 1 ? (
        <Rewards getProfileData={getProfileData} topUsersData={topUsersData} GetTopUsers={GetTopUsers}/>
      ) : tab == 2 ? (
        <YourReferral topUsersData={topUsersData}/>
      ) : tab == 3 ? (
        <TopUsers />
      ) : null}
      <Footer />
    </div>
  );
};

export default ReferralsProgram;
